// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"97e7ed57","498":"7c6de7d2","553":"c32631d6","787":"84e92630"}[chunkId] + ".chunk.js";
};